<template>
    <el-drawer
        title="热门城市排序"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-alert type="warning" show-icon title="这里仅支持对热门城市进行排序操作" :closable="false"></el-alert>
            <el-table
                :data="dataList"
                style="width: 100%"
                size="small"
                stripe
                border
                v-loading="dataLoading"
                row-key="id"
                class="sortable MT20"
            >
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column prop="homeDisplay" label="状态" show-overflow-tooltip min-width="120" >					
					<template slot-scope="scope">
					    <el-tag v-if="scope.row.homeDisplay == 1" type="success" size="mini">展示</el-tag>
					    <el-tag v-else type="info" size="mini">隐藏</el-tag>
					</template>				
				</el-table-column>
				 <el-table-column prop="activityNum" label="销售中演出" min-width="200" ></el-table-column>
            </el-table>
            <div v-if="dataList" class="MT10"><small><i class="el-icon-info"></i> 按住鼠标可拖动排序</small></div>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认</el-button>
        </div>
    </el-drawer>
</template>

<script>
import Sortable from "sortablejs";
export default {
    data(){
        return{
            drawerShow: false,
            dataLoading: false,
            btnLoading:false,
            dataList:[],
            formData:[]
        }
    },
    // mounted(){
    //     this.drag(); 
    // },
    methods:{
        close() {
            this.drawerShow = false;
        },
        show() {
            this.getData();
            this.drawerShow = true;
        },
        getData(){
            this.dataLoading = true;
            this.$request({
                url: '/city/getHotCityList',
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.dataList = result || [];
                        this.$nextTick(() => { 
                            this.drag(); 
                            this.updateSort();
                        })
                    } else {
                        this.$message.error(msg || "获取数据失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("获取数据失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });   
        },
        drag(){
            const el = document.querySelectorAll('.sortable> .el-table__body-wrapper > table > tbody')[0];
            Sortable.create(el, {
                disabled: false, // 拖拽不可用? false 启用
                ghostClass: 'sortable-ghost', //拖拽样式
                animation: 150, // 拖拽延时，效果更好看
                onEnd: (e) => { // 拖拽结束时的触发
                    let arr = this.dataList; // 获取表数据
                    arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
                    this.$nextTick(() => {
                        this.dataList = arr;
                        this.updateSort();
                    })
                },
            });
        },
        updateSort(){
            this.formData = []
            this.dataList.map((item,index) => {
                this.formData.push({
                    id: item.id,
                    sort: index
                })
            })
        },
        submitForm(){
            this.btnLoading = true;
            this.$request({
                url: '/city/setHotCitySort',
                data: this.formData
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.$emit('onUpdate');
                        this.close()
                    } else {
                        this.$message.error(msg || "操作失败,请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.btnLoading = false;
                });
        }
    }
}
</script>